import { useDispatch } from 'react-redux';
import { $actions } from 'Store/ducks';
import { useAsyncAction } from 'Hooks/Common';
import { FreezeTeamMembersPayload } from 'Interfaces/Team';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: FreezeTeamMembersPayload) =>
    $actions.team.freezeTeamMembers(dispatch, payload),
  );
};
